import { DateTime } from "luxon";

import { getDateFromIso } from "../../_helpers/stringHelper.ts";

type DiagnosticCardComponentProps = {
  isDataNotEmpty: boolean;
  title: string;
  result: any;
  date?: string;
  hasIssue?: boolean;
};

const DiagnosticCardComponent = ({
  isDataNotEmpty,
  title,
  result,
  date,
  hasIssue = false,
}: DiagnosticCardComponentProps) => {
  return isDataNotEmpty ? (
    <div className={`diagnostics_card ${hasIssue ? "alert" : ""}`}>
      <p>{title}</p>
      <div className="diagnostics_result">{result}</div>
      <div className="diagnostics_date">
        <p>{getDateFromIso(date, DateTime.DATE_SHORT, "illimité")}</p>
      </div>
    </div>
  ) : null;
};

export default DiagnosticCardComponent;
